jQuery(document).ready(function ($) {

  const carousels = document.querySelectorAll('.hubspot-blog-carousel');

  function addLatestBlogsSplideArrows(splideInstance) {
    const prevArrow = splideInstance.root.querySelector('.splide__arrow--prev');
    const nextArrow = splideInstance.root.querySelector('.splide__arrow--next');

    if (prevArrow) {
      prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="75" viewBox="0 0 24 75" fill="none">
  <rect y="0.5" width="24" height="74" rx="4" fill="#F6F6F6"></rect>
  <path d="M15.5 60.625C14.625 56.1285 12 45.5167 8.5 39.0417C9.95833 36.3438 13.4 28.25 15.5 17.4583" stroke="#BBDF06" stroke-width="2"></path>
</svg>`;
    }

    if (nextArrow) {
      nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="75" viewBox="0 0 24 75" fill="none">
  <path d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H20C22.2091 0.5 24 2.29086 24 4.5V70.5C24 72.7091 22.2091 74.5 20 74.5H4C1.79086 74.5 0 72.7091 0 70.5V4.5Z" fill="#F6F6F6"></path>
  <path d="M8.5 60.625C9.375 56.1285 12 45.5167 15.5 39.0417C14.0417 36.3438 10.6 28.25 8.5 17.4583" stroke="#BBDF06" stroke-width="2"></path>
</svg>`;
    }
  }

  carousels.forEach(function (carousel) {

    const carouselSplide = new Splide(carousel, {
      type: 'loop',
      perPage: 3,           // Three slides visible
      focus: 'center',      // Center slide is active
      gap: '0px',
      arrows: true,
      speed: 700,
      updateOnMove: true,
      pagination: true,
      trimSpace: false,     // Important to prevent empty spaces at edges
      breakpoints: {
        1024: { perPage: 1, focus: 'center' },
        640: { perPage: 1, focus: 'center' },
      },
    }).mount();
    addLatestBlogsSplideArrows(carouselSplide);

  });

});